import { render, staticRenderFns } from "./OnlineCompressLimit.vue?vue&type=template&id=783caf46&"
import script from "./OnlineCompressLimit.vue?vue&type=script&lang=js&"
export * from "./OnlineCompressLimit.vue?vue&type=script&lang=js&"
import style0 from "./OnlineCompressLimit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports